export default "<div [hidden]=\"!isLoading\" text-center>\n  <ion-spinner></ion-spinner> <span>{{ message }}</span>\n</div>\n";